import DirectoryListingCard from './DirectoryListingCard';

export default DirectoryListingCard;
